
import { Box, Divider, Stack, Grid, FormControl, Checkbox, Modal, TableCell, TableContainer, Paper, TableBody, TableRow, Table, TableHead, Typography, Autocomplete, TextField, useTheme, Button, Toolbar, IconButton, Tooltip, Tabs, Tab } from "@mui/material";
import React, { useState, useEffect } from "react";
import Header from "../../../Layout/Header";
import { tokens } from "../../../theme/theme";
import 'dayjs/plugin/customParseFormat';

import CallAlertBar from "../../../Layout/Alertbar";


import DownloadIcon from '@mui/icons-material/Download';
import SendIcon from '@mui/icons-material/Send';

import CustomTableContainer from "../../../components/table/CustomTableContainer";
import useMaterialList from "../../../hooks/useMaterialList";
import useBillOfMaterialCode from "../../../hooks/useBillofMaterialCode";
import useProductList from "../../../hooks/useProductList";
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import useBillOfMaterialMOList from "../../../hooks/useBillOfMaterialMoList";

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import Searchicon from '@mui/icons-material/Search';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


// Date picker components
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import AddNewRequestIndent from "../../purchase/request-indent/AddRequestIndent";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";

import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';


// Sample raw material options
const rawMaterials = [
    { label: "Wood Pulp" },
    { label: "Recycled Paper" },
    { label: "Cotton Linters" },
    { label: "Bagasse" },
    { label: "Straw Pulp" },
];

const layerColors = ["#78909c", "#607d8b", "#546e7a", "#455a64"]; // Colors for different layers

// Add this reusable TabPanel component to your file (before your main component)
// tab panel
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 0 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}




const GetBillOfMaterial = ({ handlecallback, editMaterialID, setEditMaterialID }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [value, setValue] = React.useState(0);

    // Parent Roll  Alert Values
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('All');

    // List of Parameter

    const [materialName, setMaterialName] = useState('');
    const [minimumReOrderQty, setMinimumReOrderQty] = useState(0);

    const [leadTimeDemand, setLeadTimeDemand] = useState(0);
    const [safetyStock, setSafetyStock] = useState(0);
    const [vendors, setVendors] = useState([]);

    const { materialCode, setMaterialCode, loadMaterialCodeByID } = useBillOfMaterialCode(editMaterialID);
    const { materialList, setMaterialList, selectMaterial, selectMaterialID, loadMaterialListByID, } = useMaterialList();
    const { productList, selectedProduct, selectedProductID, setSelectedProduct, setSelectedProductID, loadProductByID, } = useProductList(editMaterialID);
    const { moList, selectedMO, selectedMONo, setMOList, setSelectedMO, setSelectedMONo, loadMOByID, } = useBillOfMaterialMOList(editMaterialID);
    const [demandQuantity, setDemandQuantity] = useState(0);

    const [selectedMaterial, setSelectedMaterial] = useState(null);

    const [rawMaterialRows, setRawMaterialRows] = useState([]); // Stores dynamic rows
    const [chemicalMaterialRows, setChemicalMaterialRows] = useState([]); // Stores dynamic rows
    const [fuelMaterialRows, setFuelMaterialRows] = useState([]);

    const [selectedMOList, setSelectedMOList] = useState([]); // Stores dynamic rows
    const [allMaterialRows, setAllMaterialRows] = useState([]); // Stores dynamic rows
    const [allFuelRows, setAllFuelRows] = useState([]);

    const [allRawMaterialRows, setAllRawMaterialRows] = useState([]);
    const [allChemicalMaterialRows, setAllChemicalMaterialRows] = useState([]);
    const [allFuellMaterialRows, setAllFuellMaterialRows] = useState([]);
    const [showChemicalModal, setShowChemicalModal] = useState(false);
    // Add these lines with your other useState declarations
    const [activeTab, setActiveTab] = useState('raw'); // Default: raw materials



    // List of Parameter
    const [isLoadProductDetail, setLoadProductDetail] = useState(false);
    const [bomID, setBOMID] = useState(0);
    const [shiftCodes, setShiftCodes] = useState([]);
    const [selectedShiftCode, setSelectedShiftCode] = useState('');
    const [selectedShiftID, setSelectedShiftID] = useState(0);
    const [shiftDate, setShiftDate] = useState(dayjs());
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [callCalculation, setCallCalculation] = useState(false);
    const [viewMaterialTable, setViewMaterialTable] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedReamRows, setSelectedReamRows] = useState([]);

    const [enableAddMode, setEnableAddMode] = useState(false);
    const [enableAddRequestIndent, setEnableAddRequestIndent] = useState(false);

    // MA Quantity and Reel Length States
    const [totalMAQuantity, setTotalMAQuantity] = useState(0.0); // State to store total MA quantity
    const [totalReelLength, setTotalReelLength] = useState(0); // State to store total MA quantity
    const [selectedButton, setSelectedButton] = useState(null);


    const [machines, setMachines] = useState([]);
    const [machineID, setMachineID] = useState(0);
    const [machineCode, setMachineCode] = useState('');
    const [isMachineDataLoaded, setIsMachineDataLoaded] = useState(false);



    // filter 
    const [open, setOpen] = useState(false);
    const [filters, setFilters] = useState({
        material_code: '',
        material_name: '',
        status: '',
    });

    // tab change 

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };



    // Get Shift Codes
    useEffect(() => {
        if (!isDataLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
            }

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setShiftCodes(data);
                        setSelectedShiftCode(data[0]);
                        setSelectedShiftID(data[0].shiftid);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);

    // Function to add a new row
    const addRawMaterialRow = () => {
        setRawMaterialRows([
            ...rawMaterialRows,
            {
                id: rawMaterialRows.length + 1,
                material: null,
                id_material: 0,
                yield: "",
                layers: [
                    { furnish: "", tonsPerTon: "", totalTon: "" },
                    { furnish: "", tonsPerTon: "", totalTon: "" },
                    { furnish: "", tonsPerTon: "", totalTon: "" },
                    { furnish: "", tonsPerTon: "", totalTon: "" }
                ] // Only "Furnish" fields for each layer
            }
        ]);
    };

    // Function to update row values
    const updateRow = (index, field, value) => {
        const updatedRows = [...rawMaterialRows];
        if (field === 'material') {
            const material_id = parseInt(value.id_material) || 0;
            updatedRows[index][field] = value;
            updatedRows[index].id_material = material_id;
        }
        else {
            updatedRows[index][field] = value;
        }

        //id_material

        if (field === 'yield') {
            const yieldvalue = parseFloat(value) || 0;
            updatedRows[index].layers = updatedRows[index].layers.map(layer => ({
                ...layer,
                tonsPerTon: layer.furnish ? (parseFloat(layer.furnish / yieldvalue) || "").toFixed(3) : ""
            }));
        }
        setRawMaterialRows(updatedRows);
    };

    // Function to update **only the selected layer's field**
    const updateLayer = (index, layerIndex, field, value) => {
        const updatedRows = [...rawMaterialRows];
        updatedRows[index].layers[layerIndex][field] = value;

        // Calculate tonsPerTon when Furnish is updated
        const yieldValue = parseFloat(updatedRows[index].yield) || 0;
        const furnishValue = parseFloat(value) || 0;
        updatedRows[index].layers[layerIndex].tonsPerTon = furnishValue ? (furnishValue / yieldValue).toFixed(3) : "";
        setRawMaterialRows(updatedRows);
    };

    // Calculate summary values for each layer
    const summary = rawMaterialRows.reduce(
        (acc, row) => {
            row.layers.forEach((layer, i) => {
                acc.furnish[i] += parseFloat(layer.furnish) || 0;
                acc.tonsPerTon[i] += parseFloat(layer.tonsPerTon) || 0;
                acc.totalTon[i] += parseFloat(layer.totalTon) || 0;
            });
            return acc;
        },
        { furnish: [0, 0, 0, 0], tonsPerTon: [0, 0, 0, 0], totalTon: [0, 0, 0, 0] }
    );


    // Function to add a new row
    const addChemicalRow = () => {
        setChemicalMaterialRows([
            ...chemicalMaterialRows,
            {
                id: chemicalMaterialRows.length + 1,
                material: null,
                id_material: 0,
                yield: "100",
                layers: [
                    { dosage: "", kgPerTon: "", totalTon: "" },
                    { dosage: "", kgPerTon: "", totalTon: "" },
                    { dosage: "", kgPerTon: "", totalTon: "" },
                    { dosage: "", kgPerTon: "", totalTon: "" },
                ] // Only "Furnish" fields for each layer
            }
        ]);
    };

    // Function to update row values
    const updateChemicalRow = (index, field, value) => {
        const updatedRows = [...chemicalMaterialRows];
        if (field === 'material') {
            const material_id = parseInt(value.id_material) || 0;
            updatedRows[index][field] = value;
            updatedRows[index].id_material = material_id;
        }
        else {
            updatedRows[index][field] = value;
        }

        //id_material

        if (field === 'yield') {
            const yieldvalue = parseFloat(value) || 0;
            updatedRows[index].layers = updatedRows[index].layers.map(layer => ({
                ...layer,
                tonsPerTon: layer.dosage ? (parseFloat(layer.dosage * yieldvalue) || "").toFixed(3) : ""
            }));
        }
        setChemicalMaterialRows(updatedRows);
    };

    // Function to update **only the selected layer's field**
    const updateChemicalLayer = (index, layerIndex, field, value) => {
        const updatedRows = [...chemicalMaterialRows];
        updatedRows[index].layers[layerIndex][field] = value;
        // Calculate tonsPerTon when Furnish is updated
        const yieldValue = parseFloat(updatedRows[index].yield) || 0;
        const dosageValue = parseFloat(value) || 0;
        updatedRows[index].layers[layerIndex].kgPerTon = dosageValue ? ((dosageValue / yieldValue) * 100).toFixed(1) : "";
        setChemicalMaterialRows(updatedRows);
    };


    // Calculate summary values for each layer
    const chemicalSummary = chemicalMaterialRows.reduce(
        (acc, row) => {
            row.layers.forEach((layer, i) => {
                acc.dosage[i] += parseFloat(layer.dosage) || 0;
                acc.kgPerTon[i] += parseFloat(layer.kgPerTon) || 0;
                acc.totalTon[i] += parseFloat(layer.totalTon) || 0;
            });
            return acc;
        },
        { dosage: [0, 0, 0, 0], kgPerTon: [0, 0, 0, 0], totalTon: [0, 0, 0, 0] }
    );

    // Function to update row values
    const updateFuelRow = (index, field, value) => {
        const updatedRows = [...fuelMaterialRows];
        if (field === 'material') {
            const material_id = parseInt(value.id_material) || 0;
            updatedRows[index][field] = value;
            updatedRows[index].id_material = material_id;
        }
        else {
            updatedRows[index][field] = value;
        }

        //id_material

        if (field === 'yield') {
            const yieldvalue = parseFloat(value) || 0;
            updatedRows[index].layers = updatedRows[index].layers.map(layer => ({
                ...layer,
                tonsPerTon: layer.dosage ? (parseFloat(layer.dosage * yieldvalue) || "").toFixed(3) : ""
            }));
        }
        setFuelMaterialRows(updatedRows);
    };

    // Function to update **only the selected layer's field**
    const updateFuelLayer = (index, layerIndex, field, value) => {
        const updatedRows = [...fuelMaterialRows];
        updatedRows[index].layers[layerIndex][field] = value;
        // Calculate tonsPerTon when Furnish is updated
        const yieldValue = parseFloat(updatedRows[index].yield) || 0;
        const dosageValue = parseFloat(value) || 0;
        updatedRows[index].layers[layerIndex].kgPerTon = dosageValue ? ((dosageValue / yieldValue) * 100).toFixed(1) : "";
        setFuelMaterialRows(updatedRows);
    };

    // Calculate summary values for each layer
    const fuelSummary = fuelMaterialRows.reduce(
        (acc, row) => {
            row.layers.forEach((layer, i) => {
                acc.dosage[i] += parseFloat(layer.dosage) || 0;
                acc.kgPerTon[i] += parseFloat(layer.kgPerTon) || 0;
                acc.totalTon[i] += parseFloat(layer.totalTon) || 0;
            });
            return acc;
        },
        { dosage: [0, 0, 0, 0], kgPerTon: [0, 0, 0, 0], totalTon: [0, 0, 0, 0] }
    );


    // i want update  raw material and chemical value based on demand qty

    const updateRawMaterialAndChemicalBasedOnDemand = async (demandQuantity) => {

        const updatedRows = rawMaterialRows.map(row => ({
            ...row,
            layers: row.layers.map(layer => ({
                ...layer,
                totalTon: layer.tonsPerTon ? (parseFloat(layer.tonsPerTon) * demandQuantity).toFixed(3) : ""
            }))
        }));

        setRawMaterialRows(updatedRows);

        const updateChemicals = chemicalMaterialRows.map(row => ({
            ...row,
            layers: row.layers.map(layer => ({
                ...layer,
                totalTon: layer.kgPerTon ? (parseFloat(layer.kgPerTon) * demandQuantity).toFixed(3) : ""
            }))
        }));

        setChemicalMaterialRows(updateChemicals);

        const updateFuels = fuelMaterialRows.map(row => ({
            ...row,
            layers: row.layers.map(layer => ({
                ...layer,
                totalTon: layer.kgPerTon ? (parseFloat(layer.kgPerTon) * demandQuantity).toFixed(3) : ""
            }))
        }));

        setFuelMaterialRows(updateFuels);
    }


    useEffect(() => {
        if (callCalculation) {
            const fatchdata = async () => {
                await updateRawMaterialAndChemicalBasedOnDemand(demandQuantity);
                setCallCalculation(false);
            }
            fatchdata();
        }
    });




    const [rawMaterial, setRawMaterial] = useState([]);
    const [chemicalMaterial, setChemicalMaterial] = useState([]);
    const [fuelMaterial, setFuelMaterial] = useState([]);

    useEffect(() => {

        if (materialList.length > 0) {
            // Get raw material list
            const raw = materialList.filter((r) => r.category_desc === 'RAW MATERIAL');
            setRawMaterial(raw);

            // Get chemical material list
            const chemicalraw = materialList.filter((r) => r.category_desc === 'CHEMICAL AND DYES');
            setChemicalMaterial(chemicalraw);

            const fuelraw = materialList.filter((r) => r.category_desc === 'FUEL');
            setFuelMaterial(fuelraw);
        }


    }, [materialList]);


    // List of Parameter
    const [isLoadEditPO, setLoadEditPO] = useState(false);
    const [isLoadEditPO1, setLoadEditPO1] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            if (!isLoadEditPO1 && editMaterialID != 0) {
                try {
                    const para = {
                        p_companyid: localStorage.getItem("companyid"),
                        p_plantid: 1,
                        p_id_bom: editMaterialID,
                    };

                    const billOfMaterialResponse = await callApi(API_ENDPOINTS.BILL_MATERIAL_GET_DETAIL_SUMMARY, 'POST', { 'Content-Type': 'application/json' }, para);
                    const billOfMaterialDet = billOfMaterialResponse[0];
                    const productPara = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1, };

                    const [billOfMaterialData] = await Promise.all([
                        callApi(API_ENDPOINTS.MATERIAL_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, productPara),

                    ]);

                    if (billOfMaterialData && billOfMaterialData.length > 0) setMaterialList(billOfMaterialData);

                    if (billOfMaterialDet) {
                        setMaterialCode(billOfMaterialDet.bom_code);
                        loadProductByID(billOfMaterialDet.productvariety_id);
                        loadMOByID(billOfMaterialDet.mo_number);
                        setDemandQuantity(billOfMaterialDet.production_quantity);
                        updateSelectedShift(billOfMaterialDet.shift_id);
                        setShiftDate(billOfMaterialDet.bom_date);
                        setIsEdit(true);
                        updateSelectedMachineIdValue(bomID.id_machine);

                        const moData = typeof billOfMaterialDet.mo_list === "string"
                            ? JSON.parse(billOfMaterialDet.mo_list)
                            : billOfMaterialDet.mo_list;

                        // i want order by mo data   asc based on mo_number
                        moData.sort((a, b) => (a.mo_number > b.mo_number ? 1 : -1));

                        setMOList(moData);


                        //update  setSelectedReamRows(newSelectedRows);

                        let selectedModata = moData.filter((e) => e.bom_status === true).map((e) => e.mo_number);
                        setSelectedReamRows(selectedModata);


                        const productData = typeof billOfMaterialDet.bomitem_list === "string"
                            ? JSON.parse(billOfMaterialDet.bomitem_list)
                            : billOfMaterialDet.bomitem_list;

                        if (Array.isArray(productData)) {
                            const mappedRows = productData.map((item, index) => ({
                                ...item,
                                id: index + 1, // Use index instead of mappedRows.length
                                material: billOfMaterialData.find(p => p.id_material === item.id_material) || "",
                                id_material: item.id_material,
                            }));

                            setRawMaterialRows(mappedRows);
                        } else {
                            setRawMaterialRows([]);
                        }


                        const chemicalData = typeof billOfMaterialDet.bom_chemical_list === 'string'
                            ? JSON.parse(billOfMaterialDet.bom_chemical_list)
                            : billOfMaterialDet.bom_chemical_list;

                        if (Array.isArray(chemicalData)) {
                            const mappedRows = chemicalData.map((item, index) => ({
                                ...item,
                                id: index + 1, // Use index instead of mappedRows.length
                                material: billOfMaterialData.find(p => p.id_material === item.id_material) || '',
                                id_material: item.id_material,

                            }));

                            setChemicalMaterialRows(mappedRows);
                        } else {
                            setChemicalMaterialRows([]);
                        }


                        const fuelData = typeof billOfMaterialDet.bom_fuel_list === 'string'
                            ? JSON.parse(billOfMaterialDet.bom_fuel_list)
                            : billOfMaterialDet.bom_fuel_list;

                        if (Array.isArray(fuelData)) {
                            const mappedRows = fuelData.map((item, index) => ({
                                ...item,
                                id: index + 1, // Use index instead of mappedRows.length
                                material: billOfMaterialData.find(p => p.id_material === item.id_material) || '',
                                id_material: item.id_material,

                            }));

                            setFuelMaterialRows(mappedRows);
                        } else {
                            setFuelMaterialRows([]);
                        }

                        await loadProductByID(billOfMaterialDet.productvariety_id);
                        setViewMaterialTable(true);
                    }
                    else {
                        setViewMaterialTable(false);
                        setIsEdit(false);

                    }
                } catch (error) {
                    callMessage('error', error.message, 'Error');
                }
            }
        };

        fetchData();
    }, [isLoadEditPO1, editMaterialID]);



    useEffect(() => {
        const fetchData = async () => {
            if (!isLoadEditPO && bomID != 0) {
                try {
                    const para = {
                        p_companyid: localStorage.getItem("companyid"),
                        p_plantid: 1,
                        p_companyid: localStorage.getItem("companyid"),
                        p_plantid: 1,
                        p_id_bom: bomID,
                    };

                    const billOfMaterialResponse = await callApi(API_ENDPOINTS.BILL_MATERIAL_GET_DETAIL, 'POST', { 'Content-Type': 'application/json' }, para);
                    const billOfMaterialDet = billOfMaterialResponse[0];
                    const productPara = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1, };
                    const [billOfMaterialData] = await Promise.all([
                        callApi(API_ENDPOINTS.MATERIAL_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, productPara),

                    ]);


                    if (billOfMaterialData && billOfMaterialData.length > 0) setMaterialList(billOfMaterialData);

                    if (billOfMaterialDet) {
                        // setMaterialCode(billOfMaterialDet.bom_code);
                        loadProductByID(billOfMaterialDet.productvariety_id);

                        const productData = typeof billOfMaterialDet.bomitem_list === "string"
                            ? JSON.parse(billOfMaterialDet.bomitem_list)
                            : billOfMaterialDet.bomitem_list;

                        if (Array.isArray(productData)) {
                            const mappedRows = productData.map((item, index) => ({
                                ...item,
                                id: index + 1, // Use index instead of mappedRows.length
                                material: billOfMaterialData.find(p => p.id_material === item.id_material) || "",
                                id_material: item.id_material,
                            }));

                            setRawMaterialRows(mappedRows);
                        } else {
                            setRawMaterialRows([]);
                        }


                        const chemicalData = typeof billOfMaterialDet.bom_chemical_list === 'string'
                            ? JSON.parse(billOfMaterialDet.bom_chemical_list)
                            : billOfMaterialDet.bom_chemical_list;

                        if (Array.isArray(chemicalData)) {
                            const mappedRows = chemicalData.map((item, index) => ({
                                ...item,
                                id: index + 1, // Use index instead of mappedRows.length
                                material: billOfMaterialData.find(p => p.id_material === item.id_material) || '',
                                id_material: item.id_material,

                            }));

                            setChemicalMaterialRows(mappedRows);
                            setCallCalculation(true);
                            setViewMaterialTable(true);
                        } else {
                            setChemicalMaterialRows([]);
                        }

                        const fuelData = typeof billOfMaterialDet.bom_fuel_list === 'string'
                            ? JSON.parse(billOfMaterialDet.bom_fuel_list)
                            : billOfMaterialDet.bom_fuel_list;

                        if (Array.isArray(fuelData)) {
                            const mappedRows = fuelData.map((item, index) => ({
                                ...item,
                                id: index + 1, // Use index instead of mappedRows.length
                                material: billOfMaterialData.find(p => p.id_material === item.id_material) || '',
                                id_material: item.id_material,

                            }));

                            setFuelMaterialRows(mappedRows);
                            setCallCalculation(true);
                            setViewMaterialTable(true);
                        } else {
                            setFuelMaterialRows([]);
                        }


                        await loadProductByID(billOfMaterialDet.productvariety_id);

                    }
                } catch (error) {
                    callMessage('error', error.message, 'Error');
                }
            }
        };

        fetchData();
    }, [isLoadEditPO, bomID]);



    useEffect(() => {
        const fetchData = async () => {
            if (!isLoadEditPO && selectedProductID != null && selectedProductID != 0) {
                if (editMaterialID === 0) {
                    try {
                        const para = {
                            p_companyid: localStorage.getItem("companyid"),
                            p_plantid: 1,
                            p_productvariety_id: selectedProductID,
                        };

                        const billOfMaterialResponse = await callApi(API_ENDPOINTS.BILL_MATERIAL_GET_ID, 'POST', { 'Content-Type': 'application/json' }, para);
                        const billOfMaterialDet = billOfMaterialResponse[0];

                        if (billOfMaterialDet) {
                            setBOMID(billOfMaterialDet.id_bom);
                        }
                    } catch (error) {
                        callMessage('error', error.message, 'Error');
                    }
                }

            }
        };

        fetchData();
    }, [isLoadProductDetail, selectedProductID]);

    const callback = () => {
        handlecallback();
    }

    const [hideAdd, setHideAdd] = useState(true);
    const [hideSave, setHideSave] = useState(false);

    const handleAddNewMaterial = () => {
        setEditMaterialID(0);
        setMinimumReOrderQty(0);
        setSafetyStock(0);
        setLeadTimeDemand(0);
        setVendors([]);
        setMaterialName('');
        setHideAdd(true);
        setHideSave(false);
    }



    const handleSaveAndDraft = () => {

        let company_id = localStorage.getItem('companyid');
        let user = localStorage.getItem('userID');
        let selectedmode = editMaterialID === 0 ? 0 : 1;
        let id_material = editMaterialID === 0 ? 0 : editMaterialID;
        let date = new Date().toISOString().split('T')[0];

        // get selected mo list
        let selectedMOList = moList.filter((mo) => selectedReamRows.includes(mo.mo_number));

        // Use a callback to ensure we have the latest state before sending requestBody
        setTimeout(() => {
            // Validation checks
            if (!company_id) {
                callMessage('error', 'Company ID is required', 'Error');
                return;
            }

            const requestBody = {
                p_companyid: company_id,
                p_plantid: 1,
                p_mode: selectedmode,
                p_id_bom: id_material,
                p_bom_code: materialCode,
                p_bom_date: dayjs(shiftDate).format('YYYY-MM-DD HH:mm:ss'), // Fixed 24-hour format
                p_createdby: user,
                p_productvariety_id: selectedProductID,
                p_status: 'Active',
                p_bomitem_list: rawMaterialRows,
                p_bom_chemical_list: chemicalMaterialRows,
                p_bom_fuel_list: fuelMaterialRows,
                p_bom_mo_list: selectedMOList, // Ensuring updated list 
                p_shift_id: selectedShiftID,
                p_production_quantity: demandQuantity,
                p_id_machine: machineID,
            };


            // Call API or any further processing here
            callApi(API_ENDPOINTS.BILL_MATERIAL_CREATE_MO_WISE, 'POST', { 'Content-Type': 'application/json' }, requestBody)
                .then(data => {
                    if (data && data.length > 0) {
                        let msg = editMaterialID === 0 ? 'New BOM Added Successfully' : 'BOM Updated Successfully';
                        setHideSave(true);
                        setHideAdd(false);
                        callMessage('info', msg, 'info');
                    }
                })
                .catch(error => { callMessage('error', error.message, 'Error'); });
        }, 100); // Small delay to ensure state updates


    };

    const callMessage = (serverityval, msg, title) => {
        setParentRollSeverityvalue(serverityval);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(title);
        setParentRollMsgOpen(true);
    };



    const handleWinderShiftChange = (event, value) => {
        setSelectedShiftCode(value);
        setSelectedShiftID(value.shiftid);
    }

    const updateSelectedShift = (shiftID) => {
        if (shiftCodes && shiftCodes.length > 0) {
            const initialMaterialCategory = shiftCodes.find((dept) => dept.shiftid === shiftID);
            // const initialDepartment = data.find((dept) => dept.id === selectedID) || data[0];
            if (initialMaterialCategory) { // ✅ Corrected check
                setSelectedShiftCode(initialMaterialCategory);
                setSelectedShiftID(initialMaterialCategory.shiftid);
            }
        }

    }
    // export to excel data 
    const exportToExcel = () => {
        const wb = XLSX.utils.book_new();

        // Extract raw material data
        const rawMaterialData = rawMaterialRows.map((row, index) => [
            index + 1,
            row.material ? `${row.material.material_code} - ${row.material.material_name}` : "",
            row.yield,
            ...row.layers.flatMap(layer => [layer.furnish, layer.tonsPerTon, layer.totalTon])
        ]);

        // Add Summary Row
        const summaryRow = [
            "", "Summary (Total)", "",  // First 3 columns (S.No, Material, Yield)
            ...summary.furnish.flatMap((total, layerIndex) => [
                total.toFixed(2),
                summary.tonsPerTon[layerIndex].toFixed(2),
                summary.totalTon[layerIndex].toFixed(2)
            ])
        ];
        rawMaterialData.push(summaryRow); // Append summary row

        // Extract chemical data
        const chemicalData = chemicalMaterialRows.map((row, index) => [
            index + 1,
            row.material ? `${row.material.material_code} - ${row.material.material_name}` : "",
            row.yield,
            ...row.layers.flatMap(layer => [layer.dosage, layer.kgPerTon, layer.totalTon])
        ]);

        // Add Chemical Summary Row
        const chemicalSummaryRow = [
            "", "Summary (Total)", "",
            ...chemicalSummary.totalTon.map(total => total.toFixed(2))
        ];
        chemicalData.push(chemicalSummaryRow);

        // Extract chemical data
        const fuellData = fuelMaterialRows.map((row, index) => [
            index + 1,
            row.material ? `${row.material.material_code} - ${row.material.material_name}` : "",
            row.yield,
            ...row.layers.flatMap(layer => [layer.dosage, layer.kgPerTon, layer.totalTon])
        ]);

        // Add Chemical Summary Row
        const fuelSummaryRow = [
            "", "Summary (Total)", "",
            ...fuelSummary.totalTon.map(total => total.toFixed(2))
        ];
        fuellData.push(fuelSummaryRow);

        // Define headers for both tables
        const rawMaterialHeaders = [
            "S.No", "Raw Material", "Yield",
            "TOP Furnish", "TOP tons/ton", "TOP Total Tons",
            "Under Top Furnish", "Under Top tons/ton", "Under Top Total Tons",
            "Filler Furnish", "Filler tons/ton", "Filler Total Tons",
            "Back Furnish", "Back tons/ton", "Back Total Tons"
        ];

        const chemicalHeaders = ["S.No", "Chemicals", "Yield",
            "TOP Dosage", "TOP Kg/ton", "TOP Total Tons",
            "Under Top Dosage", "Under Top Kg/ton", "Under Top Total Tons",
            "Filler Dosage", "Filler Kg/ton", "Filler Total Tons",
            "Back Dosage", "Back Kg/ton", "Back Total Tons"];

        const fuelHeaders = ["S.No", "Fuels", "Yield",
            "TOP Dosage", "TOP Kg/ton", "TOP Total Tons",
            "Under Top Dosage", "Under Top Kg/ton", "Under Top Total Tons",
            "Filler Dosage", "Filler Kg/ton", "Filler Total Tons",
            "Back Dosage", "Back Kg/ton", "Back Total Tons"];

        // Create worksheet and add both tables
        const ws = XLSX.utils.aoa_to_sheet([
            rawMaterialHeaders,
            ...rawMaterialData,
            [],
            chemicalHeaders,
            ...chemicalData,
            [],
            fuelHeaders,
            ...fuellData,
        ]);

        // Auto size columns
        ws['!cols'] = rawMaterialHeaders.map(() => ({ wch: 20 }));

        // Define a border style
        const borderStyle = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" }
        };

        // Apply borders to all filled cells
        const range = XLSX.utils.decode_range(ws["!ref"]);
        for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                if (!ws[cellAddress]) continue;
                if (!ws[cellAddress].s) ws[cellAddress].s = {}; // Ensure cell style exists
                ws[cellAddress].s.border = borderStyle;
            }
        }

        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, "BOM & Chemicals");

        // Write and save file
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, "BOM_Chemicals.xlsx");
    }


    const handleCallEdit = (value, poID, poNumber) => {
        // setEditMaterialID(value);
        // setVendorHome(false);       
        // setGetBillOfMaterial(true);
    };

    // pallet list
    const handleSelectAllClickPallet = (event) => {
        if (event.target.checked) {
            const newSelectedRows = moList.map((row) => row.mo_number);
            setSelectedReamRows(newSelectedRows);
            return;
        }
        setSelectedReamRows([]);
    };

    const handleRowCheckboxClickPallet = (event, rowId) => {
        const selectedIndex = selectedReamRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedReamRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedReamRows.slice(1);
        } else if (selectedIndex === selectedReamRows.length - 1) {
            newSelectedRows = selectedReamRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedReamRows.slice(0, selectedIndex),
                ...selectedReamRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedReamRows(newSelectedRows);

    };




    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;

    const filteredData = moList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const isSelectedReam = (rowId) => selectedReamRows.indexOf(rowId) !== -1;

    const totalSelectedWeight = filteredData
        .filter((s) => selectedReamRows.includes(s.mo_number))
        .reduce((sum, row) => sum + (parseFloat(row.production_quantity) || 0), 0)
        .toFixed(1); // Limits to 1 decimal place

    const UpdateSelectedMO = () => {
        setEnableAddMode(true);
    }

    useEffect(() => {
        if (totalSelectedWeight > 0) {
            setDemandQuantity(totalSelectedWeight);
            const fatchdata = async () => {
                await updateRawMaterialAndChemicalBasedOnDemand(totalSelectedWeight);
                setCallCalculation(false);
            }
            fatchdata();
        }


    }, [totalSelectedWeight])

    useEffect(() => {
        if (!isMachineDataLoaded) {
            fetchMachineCode();
        }
    }, [isMachineDataLoaded])

    const updateSelectedMachineIdValue = async (id_machine) => {
        await fetchMachineCode(id_machine);
    };


    const fetchMachineCode = async (id_machine = null) => {
        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
        }
        // 

        try {
            const data = await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_MACHINE, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data?.length > 0) {
                setMachines(data);
                setMachineCode(data[0]);
                setMachineID(data[0].id);

                const selected = data.find(party => party.id === id_machine);
                const machineToSelect = selected || data[0];

                if (machineToSelect) {
                    setMachineCode(machineToSelect);
                    setMachineID(machineToSelect.id);
                    // setReportMachineCode(machineToSelect.machine_code);
                }
            }
        }
        catch (error) {
            // callError('error', error.message, 'Error');
            // setViewMOList(false);
            // setViewMAList(false);
            // setViewQRCode(false);
            // setViewProductionDetail(false);
        }

    }


    const handleMachineChange = (event, value) => {
        if (value != undefined || value != null) {
            setMachineCode(value);
            setMachineID(value.id);
        }
    }

    const handleBackToMoSelection = () => {
        setEnableAddMode(false);
    }

    // convert bom to request indent
    const ConvertBOMtoRequestIndent = () => {

        // Convert raw material rows
        const rawMaterialMapped = rawMaterialRows.map(item => {
            const layers = item.layers || [];
            const totalTonSum = [
                layers[0]?.totalTon,
                layers[1]?.totalTon,
                layers[2]?.totalTon,
                layers[3]?.totalTon,
            ]
                .reduce((sum, val) => sum + (parseFloat(val) || 0), 0);

            return {
                material: item.material,
                material_name: item.material.material_name,
                uom: item.material.unit_of_measurement,
                uomId: item.material.id_uom,
                id_material: item.id_material,
                id_request_det: 0,
                purpose: 'For Production',
                quantity_approved: 0,
                quantity_requested: Number(totalTonSum.toFixed(2)),
                scheduled_issue_date: new Date().toISOString().split('T')[0],
                bomId: editMaterialID,
            };
        });

        // Convert chemical material rows
        const chemicalMaterialMapped = chemicalMaterialRows.map(item => {
            const layers = item.layers || [];
            const totalTonSum = [
                layers[0]?.totalTon,
                layers[1]?.totalTon,
                layers[2]?.totalTon,
                layers[3]?.totalTon,
            ]
                .reduce((sum, val) => sum + (parseFloat(val) || 0), 0);

            return {
                material: item.material,
                material_name: item.material.material_name,
                uom: item.material.unit_of_measurement,
                uomId: item.material.id_uom,
                id_material: item.id_material,
                id_request_det: 0,
                purpose: 'For Production',
                quantity_approved: 0,
                quantity_requested: Number(totalTonSum.toFixed(2)),
                scheduled_issue_date: new Date().toISOString().split('T')[0],
                bomId: editMaterialID,
            };
        });

        // Convert chemical material rows
        const fuelMaterialMapped = fuelMaterialRows.map(item => {
            const layers = item.layers || [];
            const totalTonSum = [
                layers[0]?.totalTon,
                layers[1]?.totalTon,
                layers[2]?.totalTon,
                layers[3]?.totalTon,
            ]
                .reduce((sum, val) => sum + (parseFloat(val) || 0), 0);

            return {
                material: item.material,
                material_name: item.material.material_name,
                uom: item.material.unit_of_measurement,
                uomId: item.material.id_uom,
                id_material: item.id_material,
                id_request_det: 0,
                purpose: 'For Production',
                quantity_approved: 0,
                quantity_requested: Number(totalTonSum.toFixed(2)),
                scheduled_issue_date: new Date().toISOString().split('T')[0],
                bomId: editMaterialID,
            };
        });

        // Combine both
        const combinedList = [...rawMaterialMapped];//, ...chemicalMaterialMapped
        const combinedchemicalList = [...chemicalMaterialMapped];
        const combinedfuelList = [...fuelMaterialMapped];
        setAllMaterialRows(combinedList); // it was working 
        setAllRawMaterialRows(combinedList);
        setAllFuelRows(combinedfuelList);
        setAllChemicalMaterialRows(combinedchemicalList);
        setAllFuellMaterialRows(combinedfuelList);
        // setRawMaterialRows(rawMaterialMapped); // not working 
        // setChemicalMaterialRows(chemicalMaterialMapped); //not working
        setEnableAddRequestIndent(true);
        return combinedList;
    };









    return (<>

        {enableAddRequestIndent === false && (
            <>
                <Box padding={0}>

                    <Header title={editMaterialID == 0 ? 'Get Bill Of Material' : 'Edit Bill Of Material'} subtitle="" callback={callback} />
                    <Divider />

                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />

                    <Grid container  >

                        {enableAddMode ? (<>

                            <Grid item xs={12} xl={12} md={12} sm={12}  >
                                <Grid container display="flex-start" padding={0}>
                                    <Grid item md={0} ml="1px" mr="1px">
                                        <Tooltip title="Back to mo selection">
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <IconButton onClick={() => handleBackToMoSelection()}  >
                                                    <ArrowBackIcon style={{ fontSize: "18px", color: selectedButton === 'selectAll' ? "yellow" : "#009688" }} />
                                                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>Back to MO Selection</Typography>
                                                </IconButton>

                                            </div>
                                        </Tooltip>
                                    </Grid>
                                    <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                    <Grid item md={0} ml="1px" mr="1px">
                                        <Tooltip title="Add New">
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <IconButton onClick={handleAddNewMaterial} disabled={hideAdd}>
                                                    <AddCircleOutlineIcon style={{ fontSize: "18px", color: selectedButton === 'ParentRolls' ? "yellow" : "#009688" }} />
                                                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>Add New</Typography>
                                                </IconButton>

                                            </div>
                                        </Tooltip>
                                    </Grid>
                                    <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                    <Grid item md={0} ml="1px" mr="1px">
                                        <Tooltip title="Save BOM">
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <IconButton onClick={handleSaveAndDraft} disabled={hideSave}>
                                                    <SaveAltIcon style={{ fontSize: "18px", color: selectedButton === 'ParentRolls' ? "yellow" : "#009688" }} />
                                                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>Save BOM</Typography>
                                                </IconButton>

                                            </div>
                                        </Tooltip>
                                    </Grid>
                                    <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                    {/* Add Button */}
                                    <Grid item md={0} ml="1px" mr="1px">
                                        <Tooltip title="Download bom details to excel">
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <IconButton onClick={() => exportToExcel()}>
                                                    <DownloadIcon style={{ fontSize: "18px", color: selectedButton === 'ParentRolls' ? "yellow" : "#009688" }} />
                                                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>Download Excel</Typography>
                                                </IconButton>

                                            </div>
                                        </Tooltip>
                                    </Grid>
                                    <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                    <Grid item md={0} ml="1px" mr="1px">
                                        <Tooltip title="Download bom details to excel">
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <IconButton onClick={() => ConvertBOMtoRequestIndent()}>
                                                    <SendIcon style={{ fontSize: "18px", color: selectedButton === 'send-request' ? "yellow" : "#009688" }} />
                                                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>Send Request Indent1</Typography>
                                                </IconButton>

                                            </div>
                                        </Tooltip>
                                    </Grid>
                                    <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />

                                </Grid>
                                <Divider />
                            </Grid>

                            <Grid item xs={12} xl={12} md={12} sm={12} marginTop={2} >
                                <Grid container padding="1px 0px 10px 20px" sx={{ backgroundColor: colors.primary[400] }} spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" fontSize={14} textAlign="left">
                                            JOB Number
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={11} md={3.8} lg={6} xl={8}>
                                        <TextField size="small" value={materialCode} />
                                    </Grid>

                                </Grid>
                            </Grid>

                            {/* <Grid item xs={12} xl={12} md={12} sm={12} >
                            <Grid container padding="30px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        MO Number
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={moList}
                                        value={selectedMO}
                                        disabled={isEdit}
                                        onChange={(event, newValue) => {
                                            setSelectedMO(newValue);
                                            setSelectedMONo(newValue ? newValue.mo_number : '');
                                            loadProductByID(newValue.id_product_variety);
                                            setDemandQuantity(newValue.production_quantity);
                                            setCallCalculation(true);

                                        }}
                                        getOptionLabel={(option) =>
                                            `${option?.mo_number || ''} - ${option?.varietycode || ''}`
                                        }
                                        renderInput={(params) => (
                                            <TextField {...params} label="" placeholder="Select Product" required variant="outlined" />
                                        )}
                                    />
                                </Grid>


                            </Grid>
                        </Grid> */}

                            <Grid item xs={12} xl={12} md={12} sm={12} >
                                <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                            Machine Code
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                        <FormControl fullWidth size="small">
                                            <Autocomplete
                                                fullWidth
                                                value={machineCode}
                                                onChange={handleMachineChange}
                                                size="small"
                                                disabled={isEdit}
                                                style={{ fontSize: '12px' }}
                                                options={machines}
                                                getOptionLabel={(option) => `${option.machine_code}`}
                                                renderInput={(params) =>
                                                    <TextField required

                                                        {...params} variant="outlined" />}
                                            />
                                        </FormControl>
                                    </Grid>

                                </Grid>
                            </Grid>

                            <Grid item xs={12} xl={12} md={12} sm={12} >
                                <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={12} sm={11} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center" >
                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                            Shift Code / Date
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                        <Autocomplete
                                            fullWidth
                                            value={selectedShiftCode}
                                            onChange={handleWinderShiftChange}
                                            size="small"
                                            style={{ fontSize: '12px' }}
                                            options={shiftCodes}
                                            getOptionLabel={(option) => `${option.shiftcode}`}
                                            renderInput={(params) =>
                                                <TextField required
                                                    // helperText={errorMessage}
                                                    // error={errorMessage && errorMessage.length ? true : false}
                                                    {...params} variant="outlined" />}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <Stack spacing={2}>
                                                <DatePicker
                                                    size="small"
                                                    id="Orderdate"
                                                    value={dayjs(shiftDate)}
                                                    onChange={(date) => setShiftDate(date)}
                                                    slotProps={{ textField: { size: 'small' } }}
                                                    fullWidth
                                                    // disabled={isEdit}
                                                    className="customDatePicker"
                                                    format="DD-MMM-YYYY"
                                                    renderInput={(props) => (
                                                        <TextField
                                                            // helperText={shiftdate_errorMessage}
                                                            // error={shiftdate_errorMessage && shiftdate_errorMessage.length ? true : false}
                                                            {...props}
                                                        />
                                                    )}
                                                />
                                            </Stack>
                                        </LocalizationProvider>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} xl={12} md={12} sm={12} >
                                <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                            Demand Quantity
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                        <TextField type="number" value={demandQuantity} onChange={(e) => { setDemandQuantity(e.target.value); updateRawMaterialAndChemicalBasedOnDemand(e.target.value) }} fullWidth size="small" label="" required variant="outlined" />
                                    </Grid>

                                </Grid>
                            </Grid>

                            <Grid item xs={12} xl={12} md={12} sm={12} >
                                <Box>
                                    <Divider sx={{ marginTop: "20px" }} />
                                </Box>
                            </Grid>



                            {viewMaterialTable ? (<>

                                <ResponsiveBox
                                    customMaxHeight={{
                                        xs: '72vh', // Extra small devices (phones)
                                        sm: '72vh', // Small devices (tablets)
                                        md: '74vh', // Medium devices (small laptops)
                                        lg: '45vh', // Large devices (desktops)
                                        xl: '62vh', // Extra large devices (large desktops)
                                    }}>

                                    <Grid item xs={12} md={12} xl={12}  >
                                        <Grid container padding="5px 0px 0px 2px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                            <CustomTableContainer colors={colors}>
                                                <TableContainer  >
                                                    {/* component={Paper} */}
                                                    <Table aria-label="BOM Table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell rowSpan={2} align="center"><strong>S.No</strong></TableCell>
                                                                <TableCell rowSpan={2} align="center"><strong>Raw Material</strong></TableCell>

                                                                <TableCell rowSpan={2} align="center">
                                                                    <strong>Yield</strong>
                                                                    <br />
                                                                    {/* A = (100% - B - C) */}
                                                                </TableCell>

                                                                {["TOP Layer", "Under Top Layer", "Filler Layer", "Back Layer"].map((layer, layerIndex) => (
                                                                    <TableCell key={layer} colSpan={3} align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                        <strong>{layer}</strong>
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>

                                                            <TableRow>
                                                                {/* Columns for each layer */}
                                                                {["Furnish", "tons/ton", "Total Tons"].map((label) => (
                                                                    <TableCell key={"top-" + label} align="center" style={{ backgroundColor: "#78909c" }}>{label}</TableCell>
                                                                ))}
                                                                {["Furnish", "tons/ton", "Total Tons"].map((label) => (
                                                                    <TableCell key={"under-" + label} align="center" style={{ backgroundColor: "#607d8b" }}>{label}</TableCell>
                                                                ))}
                                                                {["Furnish", "tons/ton", "Total Tons"].map((label) => (
                                                                    <TableCell key={"filler-" + label} align="center" style={{ backgroundColor: "#546e7a" }}>{label}</TableCell>
                                                                ))}
                                                                {["Furnish", "tons/ton", "Total Tons"].map((label) => (
                                                                    <TableCell key={"back-" + label} align="center" style={{ backgroundColor: "#455a64" }}>{label}</TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {/* Data rows can be added here */}
                                                            {rawMaterialRows.map((row, index) => (
                                                                <TableRow key={row.id}>
                                                                    <TableCell align="center">{row.id}</TableCell>
                                                                    <TableCell style={{ minWidth: "250px", whiteSpace: "nowrap" }} >
                                                                        <Autocomplete
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '4px',
                                                                                    textAlign: 'left',
                                                                                },
                                                                            }}
                                                                            options={rawMaterial}
                                                                            getOptionLabel={(option) => `${option.material_code || ''} - ${option.material_name || ''}`}
                                                                            value={row.material}
                                                                            onChange={(event, newValue) => updateRow(index, "material", newValue)}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params} placeholder="Select Material" variant="outlined" fullWidth />
                                                                            )}
                                                                            size="small"
                                                                        />
                                                                    </TableCell>


                                                                    {/* Input Fields for Cost, Yield, Moisture Loss, Process Loss */}
                                                                    {["yield"].map((field) => (
                                                                        <TableCell key={field}>
                                                                            <TextField
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiInputBase-input': {
                                                                                        padding: '4px',
                                                                                        textAlign: 'center',
                                                                                    },
                                                                                }}

                                                                                type="number"
                                                                                value={row[field]}
                                                                                onChange={(e) => updateRow(index, field, e.target.value)}
                                                                                variant="outlined"
                                                                                size="small"
                                                                            />
                                                                        </TableCell>
                                                                    ))}


                                                                    {/* Layer Inputs with Background Colors (Only "Furnish" and "tonsPerTon") */}
                                                                    {row.layers.flatMap((layer, layerIndex) => [
                                                                        <TableCell key={`furnish-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <TextField
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiInputBase-input': {
                                                                                        padding: '4px',
                                                                                        textAlign: 'center',
                                                                                    },
                                                                                }}

                                                                                type="number"
                                                                                value={layer.furnish}
                                                                                // onChange={(e) => updateLayer(index, layerIndex, "furnish", e.target.value)}
                                                                                variant="outlined"
                                                                                size="small"
                                                                            />
                                                                        </TableCell>,
                                                                        <TableCell key={`tonsPerTon-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <TextField
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiInputBase-input': {
                                                                                        padding: '4px',
                                                                                        textAlign: 'center',
                                                                                    },
                                                                                }}
                                                                                type="number"
                                                                                value={layer.tonsPerTon}
                                                                                // onChange={(e) => updateLayer(index, layerIndex, "tonsPerTon", e.target.value)}
                                                                                variant="outlined"
                                                                                size="small"
                                                                            />
                                                                        </TableCell>,
                                                                        <TableCell key={`totalTon-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <TextField
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiInputBase-input': {
                                                                                        padding: '4px',
                                                                                        textAlign: 'center',
                                                                                    },
                                                                                }}
                                                                                type="number"
                                                                                value={layer.totalTon}
                                                                                // onChange={(e) => updateLayer(index, layerIndex, "totalTon", e.target.value)}
                                                                                variant="outlined"
                                                                                size="small"
                                                                            />
                                                                        </TableCell>

                                                                    ])}

                                                                </TableRow>
                                                            ))}
                                                            {/* Summary Row */}
                                                            <TableRow>
                                                                <TableCell colSpan={3} align="right"><strong>Summary (Total)</strong></TableCell>
                                                                {summary.furnish.map((total, layerIndex) => (
                                                                    <React.Fragment key={layerIndex}>
                                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <strong>{total.toFixed(2)}</strong>
                                                                        </TableCell>
                                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <strong>{summary.tonsPerTon[layerIndex].toFixed(2)}</strong>
                                                                        </TableCell>
                                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <strong>{summary.totalTon[layerIndex].toFixed(2)}</strong>
                                                                        </TableCell>
                                                                    </React.Fragment>
                                                                ))}
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </CustomTableContainer>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} xl={12}  >
                                        <Grid container padding="20px 0px 30px 2px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
                                            <CustomTableContainer colors={colors}>
                                                <TableContainer  >
                                                    {/* component={Paper} */}
                                                    <Table aria-label="BOM Table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell rowSpan={2} align="center"><strong>S.No</strong></TableCell>
                                                                <TableCell rowSpan={2} align="center" ><strong>Chemicals</strong></TableCell>

                                                                <TableCell rowSpan={2} align="center">
                                                                    <strong>Yield</strong>
                                                                    <br />
                                                                    {/* A = (100% - B - C) */}
                                                                </TableCell>

                                                                {["TOP Layer", "Under Top Layer", "Filler Layer", "Back Layer"].map((layer, layerIndex) => (
                                                                    <TableCell key={layer} colSpan={3} align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                        <strong>{layer}</strong>
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>

                                                            <TableRow>
                                                                {/* Columns for each layer */}
                                                                {["Dosage", "Kg/ton", "Total Kgs"].map((label) => (
                                                                    <TableCell key={"top-" + label} align="center" style={{ backgroundColor: "#78909c" }}>{label}</TableCell>
                                                                ))}
                                                                {["Dosage", "Kg/ton", "Total Kgs"].map((label) => (
                                                                    <TableCell key={"under-" + label} align="center" style={{ backgroundColor: "#607d8b" }}>{label}</TableCell>
                                                                ))}
                                                                {["Dosage", "Kg/ton", "Total Kgs"].map((label) => (
                                                                    <TableCell key={"filler-" + label} align="center" style={{ backgroundColor: "#546e7a" }}>{label}</TableCell>
                                                                ))}
                                                                {["Dosage", "tons/ton", "Total Tons"].map((label) => (
                                                                    <TableCell key={"back-" + label} align="center" style={{ backgroundColor: "#455a64" }}>{label}</TableCell>
                                                                ))}
                                                            </TableRow>

                                                        </TableHead>
                                                        <TableBody>
                                                            {/* Data rows can be added here */}
                                                            {chemicalMaterialRows.map((row, index) => (
                                                                <TableRow key={row.id}>
                                                                    <TableCell align="center">{row.id}</TableCell>
                                                                    <TableCell style={{ minWidth: "250px", whiteSpace: "nowrap" }}>
                                                                        <Autocomplete
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '4px',
                                                                                    textAlign: 'left',
                                                                                },
                                                                            }}
                                                                            options={chemicalMaterial}
                                                                            getOptionLabel={(option) => `${option.material_code || ''} - ${option.material_name || ''}`}
                                                                            value={row.material}
                                                                            onChange={(event, newValue) => updateChemicalRow(index, "material", newValue)}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params} placeholder="Select Material" variant="outlined" fullWidth />
                                                                            )}
                                                                            size="small"
                                                                        />
                                                                    </TableCell>


                                                                    {/* Input Fields for Cost, Yield, Moisture Loss, Process Loss */}
                                                                    {["yield"].map((field) => (
                                                                        <TableCell key={field}>
                                                                            <TextField
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiInputBase-input': {
                                                                                        padding: '4px',
                                                                                        textAlign: 'center',
                                                                                    },
                                                                                }}

                                                                                type="number"
                                                                                value={row[field]}
                                                                                // onChange={(e) => updateChemicalRow(index, field, e.target.value)}
                                                                                variant="outlined"
                                                                                size="small"
                                                                            />
                                                                        </TableCell>
                                                                    ))}


                                                                    {/* Layer Inputs with Background Colors (Only "Furnish" and "tonsPerTon") */}
                                                                    {row.layers.flatMap((layer, layerIndex) => [
                                                                        <TableCell key={`dosage-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <TextField
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiInputBase-input': {
                                                                                        padding: '4px',
                                                                                        textAlign: 'center',
                                                                                    },
                                                                                }}

                                                                                type="number"
                                                                                value={layer.dosage}
                                                                                onChange={(e) => updateChemicalLayer(index, layerIndex, "dosage", e.target.value)}
                                                                                variant="outlined"
                                                                                size="small"
                                                                            />
                                                                        </TableCell>,
                                                                        <TableCell key={`kgPerTon-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <TextField
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiInputBase-input': {
                                                                                        padding: '4px',
                                                                                        textAlign: 'center',
                                                                                    },
                                                                                }}
                                                                                type="number"
                                                                                value={layer.kgPerTon}
                                                                                // onChange={(e) => updateChemicalLayer(index, layerIndex, "kgPerTon", e.target.value)}
                                                                                variant="outlined"
                                                                                size="small"
                                                                            />
                                                                        </TableCell>,
                                                                        <TableCell key={`totalTon-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <TextField
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiInputBase-input': {
                                                                                        padding: '4px',
                                                                                        textAlign: 'center',
                                                                                    },
                                                                                }}
                                                                                type="number"
                                                                                value={layer.totalTon}
                                                                                // onChange={(e) => updateChemicalLayer(index, layerIndex, "kgPerTon", e.target.value)}
                                                                                variant="outlined"
                                                                                size="small"
                                                                            />
                                                                        </TableCell>
                                                                    ])}

                                                                </TableRow>
                                                            ))}
                                                            {/* Summary Row */}
                                                            <TableRow>
                                                                <TableCell colSpan={3} align="right"><strong>Summary (Total)</strong></TableCell>
                                                                {chemicalSummary.dosage.map((total, layerIndex) => (
                                                                    <React.Fragment key={layerIndex}>
                                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <strong>{total.toFixed(2)}</strong>
                                                                        </TableCell>
                                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <strong>{chemicalSummary.kgPerTon[layerIndex].toFixed(2)}</strong>
                                                                        </TableCell>
                                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <strong>{chemicalSummary.totalTon[layerIndex].toFixed(2)}</strong>
                                                                        </TableCell>
                                                                    </React.Fragment>
                                                                ))}
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                    {/* <Button onClick={addChemicalRow} variant="contained" color="secondary" style={{ margin: "10px" }}>
                                        Add Chemical
                                    </Button> */}
                                                </TableContainer>
                                            </CustomTableContainer>

                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} xl={12}  >
                                        <Grid container padding="20px 0px 30px 2px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
                                            <CustomTableContainer colors={colors}>
                                                <TableContainer  >
                                                    {/* component={Paper} */}
                                                    <Table aria-label="BOM Table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell rowSpan={2} align="center"><strong>S.No</strong></TableCell>
                                                                <TableCell rowSpan={2} align="center" ><strong>Fuel</strong></TableCell>

                                                                <TableCell rowSpan={2} align="center">
                                                                    <strong>Yield</strong>
                                                                    <br />
                                                                    {/* A = (100% - B - C) */}
                                                                </TableCell>

                                                                {["TOP Layer", "Under Top Layer", "Filler Layer", "Back Layer"].map((layer, layerIndex) => (
                                                                    <TableCell key={layer} colSpan={3} align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                        <strong>{layer}</strong>
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>

                                                            <TableRow>
                                                                {/* Columns for each layer */}
                                                                {["Dosage", "Kg/ton", "Total Kgs"].map((label) => (
                                                                    <TableCell key={"top-" + label} align="center" style={{ backgroundColor: "#78909c" }}>{label}</TableCell>
                                                                ))}
                                                                {["Dosage", "Kg/ton", "Total Kgs"].map((label) => (
                                                                    <TableCell key={"under-" + label} align="center" style={{ backgroundColor: "#607d8b" }}>{label}</TableCell>
                                                                ))}
                                                                {["Dosage", "Kg/ton", "Total Kgs"].map((label) => (
                                                                    <TableCell key={"filler-" + label} align="center" style={{ backgroundColor: "#546e7a" }}>{label}</TableCell>
                                                                ))}
                                                                {["Dosage", "tons/ton", "Total Tons"].map((label) => (
                                                                    <TableCell key={"back-" + label} align="center" style={{ backgroundColor: "#455a64" }}>{label}</TableCell>
                                                                ))}
                                                            </TableRow>

                                                        </TableHead>
                                                        <TableBody>
                                                            {/* Data rows can be added here */}
                                                            {fuelMaterialRows.map((row, index) => (
                                                                <TableRow key={row.id}>
                                                                    <TableCell align="center">{row.id}</TableCell>
                                                                    <TableCell style={{ minWidth: "250px", whiteSpace: "nowrap" }}>
                                                                        <Autocomplete
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '4px',
                                                                                    textAlign: 'left',
                                                                                },
                                                                            }}
                                                                            options={fuelMaterial}
                                                                            getOptionLabel={(option) => `${option.material_code || ''} - ${option.material_name || ''}`}
                                                                            value={row.material}
                                                                            onChange={(event, newValue) => updateChemicalRow(index, "material", newValue)}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params} placeholder="Select Material" variant="outlined" fullWidth />
                                                                            )}
                                                                            size="small"
                                                                        />
                                                                    </TableCell>


                                                                    {/* Input Fields for Cost, Yield, Moisture Loss, Process Loss */}
                                                                    {["yield"].map((field) => (
                                                                        <TableCell key={field}>
                                                                            <TextField
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiInputBase-input': {
                                                                                        padding: '4px',
                                                                                        textAlign: 'center',
                                                                                    },
                                                                                }}

                                                                                type="number"
                                                                                value={row[field]}
                                                                                // onChange={(e) => updateChemicalRow(index, field, e.target.value)}
                                                                                variant="outlined"
                                                                                size="small"
                                                                            />
                                                                        </TableCell>
                                                                    ))}


                                                                    {/* Layer Inputs with Background Colors (Only "Furnish" and "tonsPerTon") */}
                                                                    {row.layers.flatMap((layer, layerIndex) => [
                                                                        <TableCell key={`dosage-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <TextField
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiInputBase-input': {
                                                                                        padding: '4px',
                                                                                        textAlign: 'center',
                                                                                    },
                                                                                }}

                                                                                type="number"
                                                                                value={layer.dosage}
                                                                                onChange={(e) => updateFuelLayer(index, layerIndex, "dosage", e.target.value)}
                                                                                variant="outlined"
                                                                                size="small"
                                                                            />
                                                                        </TableCell>,
                                                                        <TableCell key={`kgPerTon-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <TextField
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiInputBase-input': {
                                                                                        padding: '4px',
                                                                                        textAlign: 'center',
                                                                                    },
                                                                                }}
                                                                                type="number"
                                                                                value={layer.kgPerTon}
                                                                                // onChange={(e) => updateChemicalLayer(index, layerIndex, "kgPerTon", e.target.value)}
                                                                                variant="outlined"
                                                                                size="small"
                                                                            />
                                                                        </TableCell>,
                                                                        <TableCell key={`totalTon-${index}-${layerIndex}`} style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <TextField
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiInputBase-input': {
                                                                                        padding: '4px',
                                                                                        textAlign: 'center',
                                                                                    },
                                                                                }}
                                                                                type="number"
                                                                                value={layer.totalTon}
                                                                                // onChange={(e) => updateChemicalLayer(index, layerIndex, "kgPerTon", e.target.value)}
                                                                                variant="outlined"
                                                                                size="small"
                                                                            />
                                                                        </TableCell>
                                                                    ])}

                                                                </TableRow>
                                                            ))}
                                                            {/* Summary Row */}
                                                            <TableRow>
                                                                <TableCell colSpan={3} align="right"><strong>Summary (Total)</strong></TableCell>
                                                                {fuelSummary.dosage.map((total, layerIndex) => (
                                                                    <React.Fragment key={layerIndex}>
                                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <strong>{total.toFixed(2)}</strong>
                                                                        </TableCell>
                                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <strong>{fuelSummary.kgPerTon[layerIndex].toFixed(2)}</strong>
                                                                        </TableCell>
                                                                        <TableCell align="center" style={{ backgroundColor: layerColors[layerIndex] }}>
                                                                            <strong>{fuelSummary.totalTon[layerIndex].toFixed(2)}</strong>
                                                                        </TableCell>
                                                                    </React.Fragment>
                                                                ))}
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>

                                                </TableContainer>
                                            </CustomTableContainer>

                                        </Grid>
                                    </Grid>


                                </ResponsiveBox>

                            </>) : (null)}
                        </>) :
                            (<>
                                <Grid item xs={12} xl={12} md={12} sm={12} >
                                    <Grid container padding="10px 0px 15px 10px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                                        <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center" >
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                Product Name
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                            <Autocomplete
                                                size="small"
                                                fullWidth
                                                options={productList}
                                                value={selectedProduct}
                                                onChange={(event, newValue) => {
                                                    setSelectedProduct(newValue);
                                                    setSelectedProductID(newValue.id);
                                                    loadMOByID(null, newValue.id);
                                                }}
                                                getOptionLabel={(option) => option.varietycode || ''}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="" placeholder="select Product" required variant="outlined" />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>


                                <Grid item xs={12} xl={12} md={12} sm={12} >
                                    <Box padding={1} display="flex" justifyContent="space-between" backgroundColor={colors.primary[400]} mt={1} mb={1}>
                                        <Typography variant="h6">
                                            Selected Rows: <strong>{selectedReamRows.length}</strong>
                                        </Typography>
                                        <Typography variant="h6">
                                            Selected Quantity: <strong>{totalSelectedWeight}</strong>
                                        </Typography>
                                    </Box>
                                    <ResponsiveBox
                                        customMaxHeight={{
                                            xs: '72vh', // Extra small devices (phones)
                                            sm: '72vh', // Small devices (tablets)
                                            md: '74vh', // Medium devices (small laptops)
                                            lg: '52vh', // Large devices (desktops)
                                            xl: '67vh', // Extra large devices (large desktops)
                                        }}>
                                        <CustomTableContainer colors={colors}>
                                            {/* table footer value */}

                                            <TableContainer >
                                                <Table size="small">
                                                    <TableHead sx={{ height: 10 }}>
                                                        <TableRow>
                                                            <TableCell>
                                                                <Checkbox size="small" sx={{
                                                                    '& .MuiSvgIcon-root': { fontSize: 14 }, // Adjust the size of the checkbox icon
                                                                    color: 'secondary' // Custom color
                                                                }}
                                                                    indeterminate={selectedReamRows.length > 0 && selectedReamRows.length < filteredData.length}
                                                                    checked={selectedReamRows.length === filteredData.length}
                                                                    onChange={handleSelectAllClickPallet}
                                                                />
                                                            </TableCell>
                                                            <TableCell>MO DATE</TableCell>
                                                            <TableCell>MO NUMBER</TableCell>
                                                            <TableCell>PRODUCT</TableCell>
                                                            <TableCell>QUANTITY</TableCell>

                                                            <TableCell>
                                                                <IconButton onClick={handleOpen}>
                                                                    <Searchicon style={{ fontSize: "16px" }} />
                                                                </IconButton>
                                                                <Modal
                                                                    open={open}
                                                                    onClose={handleClose}
                                                                    aria-labelledby="modal-modal-title"
                                                                    aria-describedby="modal-modal-description"
                                                                >
                                                                    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>

                                                                        <TextField
                                                                            label="Material Code"
                                                                            name="material_code"
                                                                            value={filters.material_code}
                                                                            onChange={handleFilterChange}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />
                                                                        <TextField
                                                                            label="Material Name"
                                                                            name="material_name"
                                                                            value={filters.material_name}
                                                                            onChange={handleFilterChange}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />
                                                                        <TextField
                                                                            label="Status"
                                                                            name="status"
                                                                            value={filters.status}
                                                                            onChange={handleFilterChange}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />
                                                                        <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                                            Apply Filter
                                                                        </Button>
                                                                    </Box>
                                                                </Modal>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {filteredData.map((row) => (
                                                            <TableRow key={row.mo_number}>
                                                                <TableCell>
                                                                    <Checkbox
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiSvgIcon-root': { fontSize: 14 }, // Adjust the size of the checkbox icon
                                                                            color: 'secondary' // Custom color
                                                                        }}
                                                                        checked={isSelectedReam(row.mo_number)}
                                                                        // disabled={row.status === 'converted'}
                                                                        onChange={(event) => handleRowCheckboxClickPallet(event, row.mo_number)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>{row.mo_date}</TableCell>
                                                                <TableCell>
                                                                    <span
                                                                        style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                                        onClick={() => handleCallEdit(row.mo_number)}
                                                                    >
                                                                        {row.mo_number}
                                                                    </span>
                                                                </TableCell>
                                                                <TableCell>{row.varietycode}</TableCell>
                                                                <TableCell>{row.production_quantity}</TableCell>

                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </CustomTableContainer>

                                    </ResponsiveBox>
                                </Grid>

                                <Grid item xs={12} xl={12} md={12} sm={12} >
                                    <Box>
                                        <Divider sx={{ marginTop: "20px" }} />
                                        <Box sx={{ display: "flex", justifyContent: "flex-end" }} >
                                            <Button onClick={() => UpdateSelectedMO()} variant="contained" sx={{ marginTop: "10px" }} color="secondary">Add Selected MO</Button>
                                        </Box>
                                    </Box>
                                </Grid>
                            </>)}
                    </Grid>


                    {/* {enableAddMode ? (<>
                <Grid container>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <Box position="fixed" sx={{ top: 'auto', bottom: 0 }}>
                            <Toolbar>
                                <Button size="small" variant="contained" color="secondary" onClick={handleAddNewMaterial} disabled={hideAdd} startIcon={<AddCircleOutlineIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Add New </Button>
                                <Button size="small" variant="contained" color="secondary" onClick={handleSaveAndDraft} disabled={hideSave} startIcon={<SaveAltIcon />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Save Material</Button>
                                <Button size="small" variant="contained" style={{ backgroundColor: "maroon" }} startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button>
                            </Toolbar>
                        </Box>
                    </Grid>
                </Grid>
            </>) : (null)} */}

                </Box>
            </>
        )}

        {/* {enableAddRequestIndent && (
            <>
                <AddNewRequestIndent handlecallback={callback} editRequestIndentID={0} setEditRequestIndentID={0} selectedMode={0} setSelectedMode={0} formMode={0} materialData={allMaterialRows} />
            </>
        )} */}



        {enableAddRequestIndent && (
            <>               

                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="secondary"
                        textColor="inherit"
                        variant="contained"
                        aria-label="full width tabs example"
                    >
                        <Tab sx={{ textTransform: "none" }} label="🥫 Raw Materials" {...a11yProps(0)} />
                        <Tab sx={{ textTransform: "none" }} label="🧪 Chemicals & Dyes" {...a11yProps(1)} />
                        <Tab sx={{ textTransform: "none" }} label="🔥 Fuels " {...a11yProps(2)} />
                    </Tabs>
                </Box>

                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                >
                    <TabPanel value={value} index={0} dir={theme.direction}>
                        <Box sx={{mb:2,mt:2}}>
                            {allRawMaterialRows?.length > 0 ? (<>
                                <AddNewRequestIndent
                                    handlecallback={callback}
                                    editRequestIndentID={0}
                                    setEditRequestIndentID={0}
                                    selectedMode={0}
                                    setSelectedMode={0}
                                    formMode={0}
                                    materialData={allRawMaterialRows || []}
                                />
                            </>) : (null)}
                        </Box>
                    </TabPanel>
                    <TabPanel value={value} index={1} dir={theme.direction}>
                        <Box sx={{mb:2,mt:2}}>
                            {allChemicalMaterialRows?.length > 0 ? (<>
                                <AddNewRequestIndent
                                    handlecallback={callback}
                                    editRequestIndentID={0}
                                    setEditRequestIndentID={0}
                                    selectedMode={0}
                                    setSelectedMode={0}
                                    formMode={0}
                                    materialData={allChemicalMaterialRows || []}
                                />
                            </>) : (null)}
                        </Box>
                    </TabPanel>
                    <TabPanel value={value} index={2} dir={theme.direction}>
                        <Box sx={{mb:2,mt:2}}>
                            {allFuellMaterialRows?.length > 0 ? (<>
                                <AddNewRequestIndent
                                    handlecallback={callback}
                                    editRequestIndentID={0}
                                    setEditRequestIndentID={0}
                                    selectedMode={0}
                                    setSelectedMode={0}
                                    formMode={0}
                                    materialData={allFuellMaterialRows || []}
                                />
                            </>) : (null)}
                        </Box>
                    </TabPanel>
                </SwipeableViews>         


               
            </>
        )}







    </>)
}
export default GetBillOfMaterial;